import { roles } from '../data/content';
import { SectionHead, delay } from './primitives';

export function Experience() {
  return (
    <section className="section" id="experience" aria-labelledby="experience-title">
      <div className="container">
        <SectionHead title="Experience" id="experience-title" />

        {roles.map((role, i) => (
          <article className="role" key={role.id} data-reveal style={delay(i * 90)}>
            <div>
              <p className="role__when">
                {role.period} · {role.location}
              </p>
              <h3 className="role__title">{role.title}</h3>
              <p className="role__org">{role.org}</p>
            </div>

            <ul className="role__bullets">
              {role.bullets.map((bullet) => (
                <li key={bullet.slice(0, 24)}>{bullet}</li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </section>
  );
}
